<!-- Breadcrumb  -->
<div class="breadcrumb-container">
    <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
        (onClickBreadcrumb)="breadcrumbClicked($event)"  data-testid="associationNewBreadcrumb" homeLink="">
    </app-campaign-3-breadcrumb>
</div>

<!-- Titolo e Bottoni -->
<div class="d-flex flex-row justify-content-between align-items-center content-header1">
    <div class="title">
        <h1 class="titleLabel" data-testid="associationTitle">{{ 'cardAssociation.associationCardClient' | translate }}</h1>
    </div>
    <div class="d-flex flex-row btn-container">
        <button data-testid="back" class="btn-page-act" (click)="back()">
            <i class="pi pi-arrow-left"></i> <span>{{ 'common.back' | translate }}</span>
        </button>
        <button data-testid="saveNewAssociation" [disabled]="saveEnabler" class="btn-page-act" (click)="onSaveForm()">
            <i class="pi pi-save"></i> <span>{{ 'common.save' | translate }}</span>
        </button>
    </div>
</div>

<div class="form-container">
<form #myForm data-testid="associationForm">
    <div class="d-flex flex-row content-header">
        <!-- Campo QrCode -->
        <div class="qr-code-container" data-testid="qrCodeContainer">
            <div class="flex-row">
                <div class="ui-g-9">
                    <app-form-fields #qrCodeChild
                        [(fieldModel)]="fieldModel.qrCode"
                        [type]="'string'"
                        [label]="'cardAssociation.load_qr' | translate"
                        [name]="'qrCode'"
                        [placeholder]="'cardAssociation.load_qr_place' | translate"
                        [required]="true"
                        [disabled]="qrEnabler"
                        data-testid="qrCodeField">
                    </app-form-fields>
                </div>
                <div class="ui-g-3" style="margin-top:40px" class="action-div">
                    <button pTooltip="{{ 'common.search' | translate }}" class="search-icon-button"
                        (click)="onEvaluateAssociation()" data-testid="searchQrCodeButton">
                        <i class="fa fas fa-search"></i>
                    </button>
                    <button pTooltip="{{ 'common.reset' | translate }}" class="reset-icon-button"
                        (click)="onReset()" data-testid="resetQrCodeButton">
                        <i class="fa fas fa-rotate-left"></i>
                    </button>
                </div>                    
            </div>
        </div>

        <!-- Altri campi in colonna -->
        <div class="field-container" style="margin-top:8px">
            <app-form-fields #storeChild
                [(fieldModel)]="fieldModel.store"
                [type]="'string'"
                [label]="'cardAssociation.store' | translate"
                [name]="'negozio'"
                [placeholder]="'cardAssociation.select_store' | translate"
                [required]="true"
                [disabled]="formEnabler"
                data-testid="storeField">
            </app-form-fields>

            <app-form-fields #customerChild
                [(fieldModel)]="fieldModel.customer"
                [type]="'string'"
                [label]="'cardAssociation.customer' | translate"
                [name]="'cliente'"
                [placeholder]="'cardAssociation.select_customer' | translate"
                [required]="true"
                [disabled]="formEnabler"
                data-testid="customerField">
            </app-form-fields>

            <div class="flex-row gap-30">
                <app-form-fields #dateReqChild
                    [(fieldModel)]="fieldModel.dateRequested"
                    [type]="'date'"
                    [label]="'cardAssociation.date_requested' | translate"
                    [name]="'dataRichiesta'"
                    [placeholder]="'cardAssociation.select_date' | translate"
                    [required]="true"
                    [disabled]="formEnabler"
                    data-testid="dateRequestedField">
                </app-form-fields>

                <app-form-fields #dateEndChild
                    [(fieldModel)]="fieldModel.dateEnd"
                    [type]="'date'"
                    [label]="'cardAssociation.date_end' | translate"
                    [name]="'dataFine'"
                    [placeholder]="'cardAssociation.select_date' | translate"
                    [required]="true"
                    [disabled]="formEnabler"
                    data-testid="dateEndField">
                </app-form-fields>
            </div>

            <div *ngIf="readyActiveCards" data-testid="activeCardList">
                <span class="titleLabel">  {{ 'cardAssociation.active_cards'| translate }}</span>
                <ul>
                    <li *ngFor="let card of activeCardList" [attr.data-testid]="'activeCardItem' + card.id">{{ card }}</li>
                </ul>
            </div>
        </div>
    </div>

<!--     <div class="ui-g-4">
        <app-form-fields #cardNumbChild
            [(fieldModel)]="fieldModel.cardNumber"
            [type]="'string'"
            [label]="'cardAssociation.card_number' | translate"
            [name]="'cardNumber'"
            [placeholder]="''"
            [required]="true"
            [disabled]="cardNumberEnabler"
            data-testid="cardNumberField">
        </app-form-fields>
    </div> -->

<div class="ui-g-4">
    <div class="form-group">
        <label for="cardNumberInput" class="same-label">
            {{ 'cardAssociation.card_number' | translate }}
            <span class="required-asterisk">*</span>
        </label>
        <input #cardNumbInput id="cardNumberInput" type="text" [(ngModel)]="fieldModel.cardNumber"
            [disabled]="cardNumberEnabler" required placeholder="" name="cardNumber" data-testid="cardNumberField"
            class="similInput" [placeholder]="'cardAssociation.card_number_placeholder' | translate"
            (keydown.enter)="onSaveForm(); $event.preventDefault()" [ngClass]="{
    'input-error': cardNumberError,
    'disabled': cardNumberEnabler
  }" />
        <div *ngIf="cardNumberError" class="error-message">
            {{ 'cardAssociation.card_number_required' | translate }}
        </div>
    </div>
</div>



    <div class="ui-g-8"></div>
</form>
</div>

<p-dialog header="{{ 'movement.confirmOperation' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true"
    [closable]="false" class="custom-dialog" data-testid="deleteDialog">

    <div class="dialog-message" data-testid="deleteDialogMessage">
        {{ 'cardAssociation.blacklistMessage'| translate }}?
    </div>

    <div class="custom-footer">
         <button type="submit" pButton label="{{ 'common.confirm' | translate }}" 
            (click)="onConfirmRisKBlacklist()" icon="pi pi-check" class="p-button-danger"
            data-testid="deleteDialogConfirm">
        </button>
        <button type="button" pButton label="{{ 'common.cancel' | translate }}" 
            (click)="closePopupDelete()" icon="pi pi-times" class="p-button-text"
            data-testid="deleteDialogCancel">
        </button>
       
    </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/card-association/new-card-association/new-card-association.component.html